import { useEffect } from 'react';

import type { Domain } from '@feathr/blackbox';

export const POLL_INTERVAL = 30_000;

export function useDomainStatusPolling(domain: Domain): void {
  useEffect(() => {
    const controller = new AbortController();
    let timeoutId: number | undefined;

    async function poll(): Promise<void> {
      // A pending domain is already being fetched, so reloading it would duplicate that request.
      // A failed reload marks the domain errored; keep polling so a transient failure recovers.
      if (!domain.isPending) {
        await domain.reload();
      }
      // A reload still in flight at unmount must not schedule another poll.
      if (!controller.signal.aborted) {
        timeoutId = window.setTimeout(() => void poll(), POLL_INTERVAL);
      }
    }

    void poll();

    return () => {
      controller.abort();
      window.clearTimeout(timeoutId);
    };
  }, [domain]);
}
